import axios from "../utils/axios";

export const getToBePlanneds = (payload) => {
    return axios.post(`/ToBePlanned/GetPaged?PageSize=${payload.pageSize}&PageNumber=${payload.pageNumber}`, payload.data);
};

export const getRecordStatusList = () => {
    return axios.get(`/ToBePlanned/GetRecordStatus`);
};

export const getToBePlannedDetailById = (payload) => {
    return axios.get(`/ToBePlanned/GetToBePlannedDetailById?id=${payload}`);
};

export const addToBePlanned = (payload) => {
    return axios.post(`/ToBePlanned/Add`, payload);
};

export const updateToBePlanned = (payload) => {
    return axios.post(`/ToBePlanned/Update`, payload);
};

export const deleteToBePlanned = (payload) => {
    return axios.post(`/ToBePlanned/Delete?id=${payload}`);
};

export const convertToPlannedMaintenance = (payload) => {
    return axios.post(`/ToBePlanned/ConvertToPlannedMaintenance?id=${payload}`);
};
